import { type FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router';

import { captureException } from '@sentry/react';

import MessageModal from 'components/admin/MessageModal';

import { deleteBlogItem } from 'services/blog';

import { P_ADMIN_BLOG, useGlobalStateObject } from 'utils';

type PropsT = {
  blogId: string;
  onCancel: () => void;
};

const RemoveBlogItemModal: FunctionComponent<PropsT> = ({
  blogId,
  onCancel,
}) => {
  const [busy, setBusy] = useState(false);

  const navigate = useNavigate();

  const gs = useGlobalStateObject();

  return (
    <MessageModal
      busy={busy}
      cancelButtonLabel="No, cancel"
      confirmButtonLabel="Yes, remove"
      icon="WARN"
      onCancel={onCancel}
      onConfirm={() => {
        void (async () => {
          try {
            setBusy(true);

            await deleteBlogItem(blogId);

            const list = gs.get('blog.list.data.items');
            const idx = list?.findIndex((item) => item.id === blogId);
            if (list && idx !== undefined && idx >= 0) {
              const neu = [...list];
              neu.splice(idx, 1);
              gs.set('blog.list.data.items', neu);
            }

            await navigate(P_ADMIN_BLOG);
          } catch (error) {
            captureException(error);
            // TODO: Proper error message!
            // eslint-disable-next-line no-alert
            alert('Failed to remove the blog item');
          } finally {
            setBusy(false);
            onCancel();
          }
        })();
      }}
    >
      <h1>Are you sure you want to remove this blog item?</h1>
      <p>This action cannot be undone.</p>
    </MessageModal>
  );
};

export default RemoveBlogItemModal;
